// extracted by mini-css-extract-plugin
module.exports = {"card":"dashboardListingCard_card__3NwJe","cardBody":"dashboardListingCard_cardBody__3wUhu","cardHeader":"dashboardListingCard_cardHeader__36noH"};